import React, { useState, useEffect } from "react";
import "./Header.css";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../Assets/logo.png";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

const Header = ({ openPopup }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    setIsMobile(false);
    navigate("/contact");
  };

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Courses", path: "/course" },
    { name: "Careers", path: "/career" },
    { name: "Register for Webinar", path: "/register-for-webinar" },
    { name: "Enroll to a Course", path: "/enroll-for-course" },
  ];

  // ✅ Track screen width changes for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
      if (window.innerWidth >= 1024) setIsMobile(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuVariants = {
    hidden: { x: "100%", opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.4, ease: "easeInOut" } },
    exit: { x: "100%", opacity: 0, transition: { duration: 0.3 } },
  };

  return (
    <header className="header">
      {/* Logo */}
      <div className="logo">
        <a href="/" aria-label="NewZeal Home">
          <motion.img
            src={logo}
            alt="NewZeal Academy Logo"
            loading="lazy"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          />
        </a>
      </div>

      {/* Desktop Nav */}
      {isDesktop && (
        <nav className="nav-links">
          {menuItems.map((item) => (
            <motion.a
              key={item.path}
              href={item.path}
              className={location.pathname === item.path ? "active" : ""}
              whileHover={{ scale: 1.1, color: "#ff6600" }}
              whileTap={{ scale: 0.95 }}
            >
              {item.name}
            </motion.a>
          ))}
        </nav>
      )}

      {/* Desktop Contact Btn */}
      {isDesktop && (
        <motion.button
          className="register-btn"
          onClick={handleClick}
          whileHover={{ scale: 1.05, backgroundColor: "#ff6600" }}
          whileTap={{ scale: 0.95 }}
        >
          Contact Us
        </motion.button>
      )}

      {/* Mobile Menu Icon */}
      {!isDesktop && (
        <div className="mobile-menu-icon" onClick={() => setIsMobile(!isMobile)}>
          {isMobile ? <FaTimes /> : <FaBars />}
        </div>
      )}

      {/* Mobile Nav */}
      <AnimatePresence>
        {!isDesktop && isMobile && (
          <motion.nav
            className="nav-links-mobile"
            variants={menuVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            {menuItems.map((item) => (
              <motion.a
                key={item.path}
                href={item.path}
                className={location.pathname === item.path ? "active" : ""}
                onClick={() => setIsMobile(false)}
                whileHover={{ x: 5, color: "#ff6600" }}
                whileTap={{ scale: 0.95 }}
              >
                {item.name}
              </motion.a>
            ))}

            <motion.button
              className="register-btn-mobile"
              onClick={handleClick}
              whileHover={{ scale: 1.05, backgroundColor: "#1c5facff" }}
              whileTap={{ scale: 0.95 }}
            >
              Contact Us
            </motion.button>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
